import axios from 'axios'

const state = () => ({
  addEmployee: []
})

const getters = {
  addEmployee(state) {
    return state.addEmployee
  }
}

const mutations = {
  SET_ADDEMPLOYEE(state, payload){
    state.addEmployee = payload
  },
  DELETE_EMPLOYEE(state, id){
    state.addEmployee = state.addEmployee.filter((x) => x.id != id);
  },
  ADD_EMPLOYEE(state, data){
    state.addEmployee.push(data);
  },
  EDIT_EMPLOYEE(state, data){
    state.addEmployee = state.addEmployee.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    });
  }
}

const actions = {
  getEmployees({commit}){
    axios.get('https://api.geomalaka.uz/api/employee/admin_the_employee/')
    .then((res)=>{
      commit("SET_ADDEMPLOYEE", res.data)
      // this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteEmployee({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/employee/admin_the_employee/${id}/`)
    .then((res)=>{
      commit("DELETE_EMPLOYEE", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addEmployees({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/employee/admin_the_employee/', payload)
    .then((res)=>{
      commit("ADD_EMPLOYEE", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editEmployee({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/employee/admin_the_employee/${payload.id}/`, payload.data)
    .then((res)=>{
      commit("EDIT_EMPLOYEE", res.data)
      this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

